import jBox from 'jbox';
import 'jbox/dist/jBox.all.css';

jQuery(document).ready(function () {

    if(jQuery('.single').length > 0) {

        new jBox('Tooltip', {
            attach: '.tooltip',
            closeOnMouseleave: true,
            onOpen: function () {
                loadJaotama();
            },
         });

        jQuery('#tooltip_left').jBox('Tooltip', {
        });

        jQuery('#tooltip_right').jBox('Tooltip', {
        });

        // Only initialize tooltip for save-resource if there's a title (user is logged out)
        const $saveResource = jQuery('#tooltip_left');
        if ($saveResource.attr('title')) {
            $saveResource.jBox('Tooltip', {
                attach: '.tooltip',
                closeOnMouseleave: true,
            });
        }
    }

    function loadJaotama(){

        var links = document.querySelectorAll(window.jaotama_window_opener_class);
        var _a = links;

        var _f = function _f(link) {
            return link.addEventListener('click', openShareDialog);
        };

        for (var _i = 0; _i < _a.length; _i++) {
            _f(_a[_i], _i, _a);
        }

        undefined;

        function openShareDialog(e) {

            e.preventDefault();

            var url = this.getAttribute('href'),
                width = 600,
                height = 300,
                top = window.top.outerHeight / 2 + window.top.screenY - height / 2,
                left = window.top.outerWidth / 2 + window.top.screenX - width / 2;

            if(e.target.parentElement.parentElement.parentElement.classList.contains('copylink') ||  e.target.parentElement.parentElement.classList.contains('copylink')  || e.target.parentElement.classList.contains('copylink') ||  e.target.classList.contains('copylink')){
                navigator.clipboard.writeText(url)
            }else{
                window.open(url, '', 'width=' + width + ', height=' + height + ', top=' + top + ', left=' + left);
                console.log('this shhould not happen');
            }

        }
    }


    jQuery(".jaotama__window-opener.copylink").on('click', function(event){
        // Remove any existing copied messages
        jQuery('.copied-link').remove();
        
        var $copiedElement = jQuery("<span>");
        $copiedElement.addClass('copied-link').text('Copied!');
        jQuery(this).append($copiedElement);
        $copiedElement.fadeIn(300);
        
        // Add setTimeout to delay the fadeOut by 1000ms (1 second)
        setTimeout(function() {
            $copiedElement.fadeOut(500, function() {
                // Remove the element after fade out completes
                jQuery(this).remove();
            });
        }, 300);
    });

});
